

















































































import {Component, Emit, Prop, Vue} from "vue-property-decorator";

import ChargeApi from "@/consoleapi/api/charge";

@Component
export default class ChangeCreditInput extends Vue {
    @Prop() bearerToken!: string;
    @Prop() accountId!: string;
    @Prop() userId!: string;

    @Prop() taxExclusion!: number;
    @Prop() tax!: number;
    @Prop() taxIncluded!: number;
    @Prop() date!: string;
    @Prop() outstandingInvoiceId!: string;

    private phoneNumber = '';
    private mailAddress = '';
    private creditCardName = '';
    private creditCardNumber = '';
    private creditCardExpirationYear = '';
    private creditCardExpirationMonth = '';

    public thisYear = '';

    mounted(): void {
        // クレジットカードフォーム用
        const date = new Date();
        this.thisYear = date.getFullYear().toString().substr(2,2);
    }

    goConfirmPage(event: Event) {
        if (event) {
            event.preventDefault()
        }
        if(!this.validation()) {
            return;
        }
        const chargeApi = new ChargeApi();
        chargeApi.setBearerToken(this.bearerToken);
        chargeApi.post(this.accountId, this.creditCardNumber, this.creditCardExpirationYear, this.creditCardExpirationMonth, this.creditCardName, this.phoneNumber, this.mailAddress).then(response => {
            console.log(response.data);
            this.$store.dispatch('changeCredit/pushProgress', 'result');
        }).catch(error => {
            console.log(error.response);
            alert('カード変更に失敗しました。\n' + error.response.statusText)
        });
    }

    private validation(){
        if (!this.creditCardName) {
            alert('クレジットカード名義を入力してください。');
            return false;
        }
        if (!this.creditCardNumber) {
            alert('クレジットカード番号を入力してください。');
            return false;
        }
        if (!this.creditCardExpirationYear) {
            alert('有効期限年を指定してください。');
            return false;
        }
        if (!this.creditCardExpirationMonth) {
            alert('有効期限月を指定してください。');
            return false;
        }
        if (!this.phoneNumber) {
            alert('電話番号を入力してください。');
            return false;
        }
        if (!this.mailAddress) {
            alert('メールアドレスを入力してください。');
            return false;
        } else if (!this.validEmail(this.mailAddress)){
            alert('メールアドレスの形式に誤りがあります。');
            return false;
        }
        return true;
    }

    private calcYear(index: number){
        return Number(this.thisYear) + index - 1;
    }

    validEmail (email: string){
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }
}
